// -----------------------------------------------------------------------------
// Component Includes
// -----------------------------------------------------------------------------
import extendJquery from '@plugins/extend-jquery';
import Animate from '@plugins/animate';
import loading from '@plugins/loading';

import siteHeader from '@components/site-header';
import mobileMenu from '@components/mobile-menu';
import testimonialSlider from '@components/testimonial-slider';
import eventsSlider from '@components/events-slider';
import eventsSubNav from '@components/events-sub-nav';
import columnsSlider from '@components/columns-slider';
import fullWidthSlider from '@components/full-width-slider';
import imageSlider from '@components/image-slider';
import accordion from '@components/accordion';
import topicsAccordion from '@components/topics-accordion';
import socialShare from '@components/social-share';
import breadcrumbs from '@components/breadcrumbs';
import promoMembership from '@components/promo-membership';
import alertBanner from '@components/alert-banner';
import committeeMembershipPanel from '@components/committee-membership-panel';
import topicsColumns from '@components/topics-columns';
import sourceSubNav from '@components/source-sub-nav';
// import disqus from '@components/disqus';
import relatedItems from '@components/related-items';
import tooltip from '@components/tooltip';
import modal from '@components/modal';
import zoomableImage from '@components/zoomable-image';
import NewsList from '@components/news-list';
import MagazineIssues from '@components/magazine-issues';
import findAGroupSearch from '@components/find-a-group-search';
import coveoFilterController from '@components/coveo-filter-controller';
import brightcovePlaylistEmbed from '@components/brightcove-video-playlist-embed';

import formValidation from '@plugins/form-validation';
import jsLinkEvent from '@plugins/js-link-event';
import jumpLinks from '@plugins/jump-links';
import accessibilityOverrides from '@plugins/accessibility-overrides';

window.$ = jQuery;

(($) => {

  // Document Ready
  $(() => {

    // -----------------
    // High-priority JS
    // -----------------
    extendJquery();

    new Animate('[data-animation]');

    // this is how you can make animations trigger from 50px from the bottom of the viewport instead of the default 100px
    // new Animate('[data-animation]', '0px 0px -50px 0');

    loading();

    if ($('.news-list').length) {
      new NewsList().init();
    }

    if ($('.magazine-issues').length) {
      new MagazineIssues().init();
    }

    findAGroupSearch();
    coveoFilterController();
    accessibilityOverrides();

    // -----------------
    // Low-priority JS
    // -----------------
    siteHeader();
    mobileMenu();
    testimonialSlider();
    eventsSlider();
    eventsSubNav();
    columnsSlider();
    fullWidthSlider();
    imageSlider();
    accordion();
    topicsAccordion();
    socialShare();
    brightcovePlaylistEmbed();
    breadcrumbs();
    promoMembership();
    alertBanner();
    committeeMembershipPanel();
    topicsColumns();
    sourceSubNav();
    relatedItems();
    tooltip();
    modal();
    zoomableImage();
    // disqus();

    formValidation();
    jsLinkEvent();
    jumpLinks();

  });

})($);
